import { AreaOfInterestType } from "api/type";

const BackArms =
  "https://clinic-os.com/flow-assets/select-area-of-interest/back-arms.png";
const BackBack =
  "https://clinic-os.com/flow-assets/select-area-of-interest/back-back.png";
const BackButt =
  "https://clinic-os.com/flow-assets/select-area-of-interest/back-butt.png";
const BackHead =
  "https://clinic-os.com/flow-assets/select-area-of-interest/back-head.png";
const BackLegs =
  "https://clinic-os.com/flow-assets/select-area-of-interest/back-legs.png";
const FrontArms =
  "https://clinic-os.com/flow-assets/select-area-of-interest/front-arms.png";
const FrontBreast =
  "https://clinic-os.com/flow-assets/select-area-of-interest/front-breast.png";
const FrontHead =
  "https://clinic-os.com/flow-assets/select-area-of-interest/front-head.png";
const FrontLegs =
  "https://clinic-os.com/flow-assets/select-area-of-interest/front-legs.png";
const FrontTorso =
  "https://clinic-os.com/flow-assets/select-area-of-interest/front-torso.png";
const FrontVaginal =
  "https://clinic-os.com/flow-assets/select-area-of-interest/front-vaginal.png";

export interface ImageData {
  image: string;
  areaOfInterest: AreaOfInterestType;
}

export interface ButtonData {
  top: string;
  left: string;
  width: string;
  height: string;
  areaOfInterest: AreaOfInterestType;
}

export const backImageData: ImageData[] = [
  {
    image: BackArms,
    areaOfInterest: AreaOfInterestType.ARMS,
  },
  {
    image: BackLegs,
    areaOfInterest: AreaOfInterestType.LEGS,
  },
  {
    image: BackBack,
    areaOfInterest: AreaOfInterestType.BACK,
  },
  {
    image: BackButt,
    areaOfInterest: AreaOfInterestType.BUTT,
  },
  {
    image: BackHead,
    areaOfInterest: AreaOfInterestType.HEAD,
  },
];

export const frontImageData: ImageData[] = [
  {
    image: FrontArms,
    areaOfInterest: AreaOfInterestType.ARMS,
  },
  {
    image: FrontLegs,
    areaOfInterest: AreaOfInterestType.LEGS,
  },
  {
    image: FrontBreast,
    areaOfInterest: AreaOfInterestType.BREAST,
  },
  {
    image: FrontHead,
    areaOfInterest: AreaOfInterestType.FACE,
  },
  {
    image: FrontTorso,
    areaOfInterest: AreaOfInterestType.TORSO,
  },
  {
    image: FrontVaginal,
    areaOfInterest: AreaOfInterestType.VAGINAL,
  },
];

export const frontButtonData: ButtonData[] = [
  {
    areaOfInterest: AreaOfInterestType.ARMS,
    top: "17%",
    left: "7%",
    width: "17%",
    height: "38%",
  },
  {
    areaOfInterest: AreaOfInterestType.ARMS,
    top: "17%",
    left: "77%",
    width: "17%",
    height: "38%",
  },
  {
    areaOfInterest: AreaOfInterestType.LEGS,
    top: "44%",
    left: "20%",
    width: "60%",
    height: "45%",
  },
  {
    areaOfInterest: AreaOfInterestType.BREAST,
    top: "15%",
    left: "23%",
    width: "54%",
    height: "14%",
  },
  {
    areaOfInterest: AreaOfInterestType.FACE,
    top: "2%",
    left: "35%",
    width: "30%",
    height: "13%",
  },
  {
    areaOfInterest: AreaOfInterestType.TORSO,
    top: "29%",
    left: "23%",
    width: "54%",
    height: "15%",
  },
  {
    areaOfInterest: AreaOfInterestType.VAGINAL,
    top: "41%",
    left: "40%",
    width: "20%",
    height: "6%",
  },
];

export const backButtonData: ButtonData[] = [
  {
    areaOfInterest: AreaOfInterestType.ARMS,
    top: "17%",
    left: "7%",
    width: "17%",
    height: "38%",
  },
  {
    areaOfInterest: AreaOfInterestType.ARMS,
    top: "17%",
    left: "77%",
    width: "17%",
    height: "38%",
  },
  {
    areaOfInterest: AreaOfInterestType.LEGS,
    top: "46%",
    left: "20%",
    width: "60%",
    height: "43%",
  },
  {
    areaOfInterest: AreaOfInterestType.BACK,
    top: "15%",
    left: "23%",
    width: "54%",
    height: "22%",
  },
  {
    areaOfInterest: AreaOfInterestType.BUTT,
    top: "37%",
    left: "20%",
    width: "60%",
    height: "9%",
  },
  {
    areaOfInterest: AreaOfInterestType.HEAD,
    top: "2%",
    left: "35%",
    width: "30%",
    height: "13%",
  },
];
